<template>
    <div class="flex flex-wrap">
        <button :type="type" :disabled="disabled" :class="{
            'border border-gray-600 bg-opacity-20 bg-gray-200 text-white': disabled === true,
            'border border-transparent bg-blue-600 text-white hover:bg-blue-500 focus:border-blue-700 ': color === 'primary' && disabled === false,
            'border border-transparent bg-red-600 text-white hover:bg-red-500 focus:border-red-700': color === 'danger' && disabled === false,
            'border border-transparent bg-orange-600 text-white hover:bg-orange-500 focus:border-orange-700': color === 'warning' && disabled === false,
            'border border-transparent bg-green-600 text-white hover:bg-green-500 focus:border-green-700': color === 'success' && disabled === false,
            'border border-transparent bg-grey-600 text-white hover:bg-grey-500 focus:border-grey-700': color === 'dark' && disabled === false,
            'border border-transparent bg-gray-600 text-white hover:bg-gray-400 focus:border-gray-500 ': color === 'gray' && disabled === false,
            'border border-gray-500 bg-opacity-60 bg-gray-500 text-white hover:bg-opacity-100 ': color === 'theme' && disabled === false,
            'border border-gray-400 bg-white text-gray-700 hover:text-gray-500 focus:border-blue-300': color === 'light' && disabled === false,
            // 'border border-gray-400 bg-white text-gray-700 opacity-50 pointer-events-none': color === 'disabled' && disabled === false,
            'flex justify-center items-center  rounded-md px-1 py-1 text-base leading-6 font-medium shadow-sm focus:outline-none focus:ring-red transition ease-in-out duration-150 sm:text-xs sm:leading-5': color !== 'rooster'
        }" :style="{ height: height ? height : null, width: width ? width : null }" ref="btnRef"
            v-on:mouseenter="toggleTooltip()" v-on:mouseleave="toggleTooltip()">
            <template v-if="icon !== undefined">
                <img :src=this.icon width="25" :class="{ 'opacity-30': disabled === true }">
            </template>

            <template v-else>
                <slot></slot>
            </template>
        </button>

        <div v-if="disabled === false" ref="tooltipRef" v-bind:class="{ 'hidden': !tooltipShow, 'block': tooltipShow }"
            class="bg-gray-800 opacity-90 border-2 border-blue-300  block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg">
            <div>
                <div
                    class="bg-gray-400 text-white opacity-75 font-semibold p-1 pl-3 mb-0 border-b border-solid border-slate-100 ">
                    <slot></slot>
                </div>
                <div class="text-white p-3">
                    <img :src=this.docicon />
                    <div>
                        <div>{{ title }}</div>
                        <div v-if="shortcut !== undefined">shortcut: {{ shortcut }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { createPopper } from "@popperjs/core";
export default {
    props: {
        type: {
            required: false,
            type: String,
            default: 'button'
        },
        color: {
            required: false,
            type: String,
            default: 'primary'
        },
        title: {
            required: false,
            type: String,
            default: ''
        },
        height: {
            required: false,
            type: String,
            default: "30px",
        },
        width: {
            required: false,
            type: String,
            default: "100%",
        },
        src: {
            required: false,
            type: String
        },
        icon: {
            required: false,
            type: String
        },
        docicon: {
            required: false,
            type: String
        },
        shortcut: {
            required: false,
            type: String,
            default: undefined
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            tooltipShow: false,
        }
    },
    methods: {
        toggleTooltip: function () {
            if (this.tooltipShow) {
                this.tooltipShow = false;
            } else {
                if (this.docicon || this.title) {
                    this.tooltipShow = true;
                    createPopper(this.$refs.btnRef, this.$refs.tooltipRef, {
                        placement: "right"
                    });
                }
            }
        }
    }
}
</script>